module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_ccp-4aa93321dac504d0b296669a349c7bb9.png";